// routes
import React from 'react'
import { PATH_DASHBOARD } from '../../../routes/paths'
// components
import Label from '../../../components/Label'
import Iconify from '../../../components/Iconify'
import SvgIconStyle from '../../../components/SvgIconStyle'

// ----------------------------------------------------------------------

const getIcon = (name: string) => (
	<SvgIconStyle src={`/assets/icons/navbar/${name}.svg`} sx={{ width: 1, height: 1 }} />
)

const ICONS = {
	blog: getIcon('ic_blog'),
	cart: getIcon('ic_cart'),
	chat: getIcon('ic_chat'),
	mail: getIcon('ic_mail'),
	user: getIcon('ic_user'),
	kanban: getIcon('ic_kanban'),
	banking: getIcon('ic_banking'),
	booking: getIcon('ic_booking'),
	invoice: getIcon('ic_invoice'),
	calendar: getIcon('ic_calendar'),
	ecommerce: getIcon('ic_ecommerce'),
	analytics: getIcon('ic_analytics'),
	dashboard: getIcon('ic_dashboard'),
	menuItem: getIcon('ic_menu_item'),
}

const navConfig = [
	// GENERAL
	// ----------------------------------------------------------------------
	{
		subheader: 'Your NFT',
		items: [
			{ title: 'welcome', path: PATH_DASHBOARD.general.app, icon: ICONS.analytics },
			{ title: 'configure', path: PATH_DASHBOARD.general.configure, icon: ICONS.user },
			{ title: 'train', path: PATH_DASHBOARD.general.train, icon: ICONS.dashboard },
		],
	},
	// MANAGEMENT
	// ----------------------------------------------------------------------
	/*
	{
		subheader: 'This Unreal NFT',
		items: [
     	// BLOG
			{
				title: 'spaces',
				path: PATH_DASHBOARD.spaces.root,
				icon: ICONS.blog,
				children: [
					{ title: 'view all', path: PATH_DASHBOARD.spaces.all },
				],
			},
		],
	}, */
	/* {
		subheader: 'Manage Collection',
		items: [
			{ title: 'My NFTs', path: PATH_DASHBOARD.general.nfts, icon: ICONS.kanban },
		],
	}, */
]

export default navConfig
